import { createSelector } from "reselect";

import { Product } from "../../models";
import { RootState } from "../../store/types";
import { Step1State } from "./reducer";

// Dimensions are specified as decimals in DB; need to convert to proper precision strings for browser use
const transformDimension = (dimension: string, precision = 1): string => {
  if (dimension == null) {
    return dimension;
  }

  return (+(+dimension).toFixed(precision)).toString();
};

// TODO: Put model transforms somewhere (probably near models?); should also replace all the
//  "underscore_case" keys
const transformProduct = (product: Product): Product => ({
  ...product,
  default_dimension_width: transformDimension(product.default_dimension_width),
  default_dimension_height: transformDimension(
    product.default_dimension_height,
  ),
  default_dimension_depth: transformDimension(product.default_dimension_depth),
});

export const step1 = (state: RootState): Step1State => state.step1;
export const categories = createSelector(step1, state => state.categories);
export const isCategoriesLoading = createSelector(
  step1,
  state => state.isCategoriesLoading,
);

export const chosenProduct = createSelector(
  step1,
  state =>
    state.chosenProduct ? transformProduct(state.chosenProduct) : undefined,
);

export const chosenCategory = createSelector(
  step1,
  state => state.chosenCategory,
);



// WEBPACK FOOTER //
// ./src/routes/Step1/selectors.ts